type SortItem = {
  weight?: number | null;
};
export const weightSorter = <T extends SortItem>(items: T[]): T[] => {
  if (!items || !items.length) return [];

  return [...items].sort((a, b) => {
    const hasWeightA = typeof a.weight === "number";
    const hasWeightB = typeof b.weight === "number";

    // Case 1: both have weight → sort by ascending weight
    if (hasWeightA && hasWeightB) {
      if (a.weight! !== b.weight!) {
        return a.weight! - b.weight!;
      }
      // same weight → fall through to date
    }

    // Case 2: only A has weight → A first
    if (hasWeightA && !hasWeightB) return -1;

    // if (!hasWeightA && hasWeightB)
    return 1;
  });
};
